var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { FieldProvider, FieldConsumer } from "../field/FieldContext";
import { splitBoxProps } from "../../utils";
import Box from "../../box/Box";
import ToggleIcon from "./ToggleIcon";
import styled from "../../themes/styled";
import { ifProp, theme } from "styled-tools";
var StyledBorder = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    position: relative;\n    overflow: hidden;\n    border-width: 2px;\n    border-radius: 4px;\n    border-style: solid;\n    border-color: ", ";\n    &:focus-within {\n        outline-width: 5px;\n        outline-style: solid;\n        outline-color: Highlight;\n        @media (-webkit-min-device-pixel-ratio: 0) {\n            outline-color: -webkit-focus-ring-color;\n            outline-style: auto;\n        }\n    }\n"], ["\n    box-sizing: border-box;\n    position: relative;\n    overflow: hidden;\n    border-width: 2px;\n    border-radius: 4px;\n    border-style: solid;\n    border-color: ", ";\n    &:focus-within {\n        outline-width: 5px;\n        outline-style: solid;\n        outline-color: Highlight;\n        @media (-webkit-min-device-pixel-ratio: 0) {\n            outline-color: -webkit-focus-ring-color;\n            outline-style: auto;\n        }\n    }\n"])), ifProp("checked", theme("component.formfield.active.borderColor"), theme("component.formfield.initial.borderColor")));
function Toggle(props) {
    var _a = splitBoxProps(props), boxProps = _a[0], otherProps = _a[1];
    var children = otherProps.children, helperText = otherProps.helperText, label = otherProps.label, labelPosition = otherProps.labelPosition, error = otherProps.error, icon = otherProps.icon, isValid = otherProps.isValid, onBlur = otherProps.onBlur, onFocus = otherProps.onFocus, _b = otherProps.variant, variant = _b === void 0 ? "normal" : _b, inputProps = __rest(otherProps, ["children", "helperText", "label", "labelPosition", "error", "icon", "isValid", "onBlur", "onFocus", "variant"]);
    return (React.createElement(FieldProvider, __assign({}, inputProps, { isValid: isValid, error: error, onBlur: onBlur, onFocus: onFocus }),
        React.createElement(FieldConsumer, null, function (_a) {
            var onBlur = _a.onBlur, onFocus = _a.onFocus, htmlId = _a.htmlId;
            return (React.createElement(StyledBorder, __assign({ checked: inputProps.checked }, boxProps),
                React.createElement(Box, { as: "label", htmlFor: htmlId, display: "flex", alignItems: "center", p: 1, flexDirection: labelPosition === "left" ? "row-reverse" : "row", style: { cursor: "pointer" } },
                    React.createElement(Box, { py: variant === "compact" ? 1 : 4, pl: labelPosition === "left" ? 2 : 4, pr: labelPosition === "left" ? 4 : 2, display: "flex", justifyContent: "center", alignItems: "center" },
                        React.createElement("input", __assign({ style: { opacity: 0, width: 0, height: 0 }, onBlur: onBlur, onFocus: onFocus }, inputProps, { id: htmlId })),
                        React.createElement(ToggleIcon, { checked: inputProps.checked, type: inputProps.type })),
                    React.createElement(Box, { flex: "1", alignItems: "center", p: 2 }, children))));
        })));
}
Toggle.defaultProps = {
    labelPosition: "right",
    type: "checkbox",
    my: 2,
};
export default Toggle;
var templateObject_1;
//# sourceMappingURL=Toggle.js.map